import React, { useState, useRef } from 'react';

function Experiencias() {
    const [isPlaying, setIsPlaying] = useState(false);
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const videoRef = useRef(null);

    // Array de imágenes para el carrusel (puedes reemplazar estas rutas con tus imágenes)
    const images = [
        '/assets/imgs/productos/citricos-naturales-experiencias.jpg',
        '/assets/imgs/productos/citricos-naturales-experiencias-2.jpg', // Reemplaza con tu segunda imagen
        '/assets/imgs/productos/citricos-naturales-experiencias-3.jpg'  // Reemplaza con tu tercera imagen
    ];

    const handlePlay = (e) => {
        e.preventDefault();
        setIsPlaying(true);
        if (videoRef.current) {
            videoRef.current.play();
        }
    };

    const handleDotClick = (index) => {
        setCurrentImageIndex(index);
    };

    return (
        <section id="experiencias" className="experiencias section-padding sub-bg">
            <style jsx>{`
                @media screen and (max-width: 768px) {
                    #experiencias p {
                        text-align: justify !important;
                    }
                }
            `}</style>
            <div className="container">
                <div className="row">
                    <div className="col-lg-6 valign">
                        <div className="cont md-mb50">
                            <h6 className="sub-title main-color mb-15">Experiencias</h6>
                            <h3 className="mb-30 fw-700">
                                El Secreto de los <br /> Mejores Cócteles
                            </h3>
                            <p className="mb-40">
                                Nuestro zumo de naranja es el preferido por bartenders y mixólogos expertos.
                                Gracias a su pureza y sabor auténtico, es el ingrediente ideal para elevar
                                la calidad de cócteles clásicos y creaciones de autor.
                            </p>
                            <div className="niche-features">
                                <div className="item d-flex align-items-center mb-30">
                                    <div className="icon mr-20">
                                        <span className="icon-img-40">
                                            <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                        </span>
                                    </div>
                                    <div>
                                        <h5 className="fw-600 fz-18">Nicho Coctelero</h5>
                                        <p className="fz-14">Sabor consistente y natural para mezclas perfectas.</p>
                                    </div>
                                </div>
                                <div className="item d-flex align-items-center">
                                    <div className="icon mr-20">
                                        <span className="icon-img-40">
                                            <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                <path d="M2 12H22" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                <path d="M12 2C14.5013 4.73835 15.9228 8.29203 16 12C15.9228 15.708 14.5013 19.2616 12 22C9.49872 19.2616 8.07725 15.708 8 12C8.07725 8.29203 9.49872 4.73835 12 2Z" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                        </span>
                                    </div>
                                    <div>
                                        <h5 className="fw-600 fz-18">Alta Demanda</h5>
                                        <p className="fz-14">Apetecido en bares y restaurantes de prestigio.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="imgs" style={{ position: 'relative', height: '100%' }}>
                            <div className="img-1" style={{ position: 'relative', overflow: 'hidden', borderRadius: '0', height: '600px', width: '100%' }}>
                                {!isPlaying ? (
                                    <>
                                        <img
                                            src={images[currentImageIndex]}
                                            alt={`Cocteles ${currentImageIndex + 1}`}
                                            style={{
                                                width: '100%',
                                                height: '100%',
                                                objectFit: 'cover',
                                                display: 'block',
                                                transition: 'opacity 0.5s ease-in-out'
                                            }}
                                        />
                                        <div className="play-button" style={{
                                            position: 'absolute',
                                            top: '50%',
                                            left: '50%',
                                            transform: 'translate(-50%, -50%)',
                                            zIndex: 10
                                        }}>
                                            <a href="#0" onClick={handlePlay} className="vid d-flex align-items-center justify-content-center" style={{
                                                width: '80px',
                                                height: '80px',
                                                background: '#fff',
                                                borderRadius: '50%',
                                                cursor: 'pointer',
                                                boxShadow: '0 0 20px rgba(0,0,0,0.2)'
                                            }}>
                                                <span className="icon" style={{ marginLeft: '5px' }}>
                                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M5 3L19 12L5 21V3Z" fill="#000" stroke="#000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                    </svg>
                                                </span>
                                            </a>
                                        </div>

                                        {/* Indicadores del carrusel */}
                                        <div className="carousel-indicators" style={{
                                            position: 'absolute',
                                            bottom: '20px',
                                            left: '50%',
                                            transform: 'translateX(-50%)',
                                            display: 'flex',
                                            gap: '12px',
                                            zIndex: 15
                                        }}>
                                            {images.map((_, index) => (
                                                <button
                                                    key={index}
                                                    onClick={() => handleDotClick(index)}
                                                    aria-label={`Ir a imagen ${index + 1}`}
                                                    style={{
                                                        width: currentImageIndex === index ? '32px' : '12px',
                                                        height: '12px',
                                                        borderRadius: '6px',
                                                        border: 'none',
                                                        background: currentImageIndex === index
                                                            ? '#fff'
                                                            : 'rgba(255, 255, 255, 0.5)',
                                                        cursor: 'pointer',
                                                        transition: 'all 0.3s ease',
                                                        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.2)',
                                                        padding: 0
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        if (currentImageIndex !== index) {
                                                            e.target.style.background = 'rgba(255, 255, 255, 0.8)';
                                                        }
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        if (currentImageIndex !== index) {
                                                            e.target.style.background = 'rgba(255, 255, 255, 0.5)';
                                                        }
                                                    }}
                                                />
                                            ))}
                                        </div>
                                    </>
                                ) : (
                                    <video
                                        ref={videoRef}
                                        src="/assets/imgs/productos/citricos-naturales-video-experiencias.mp4"
                                        controls
                                        autoPlay
                                        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                    >
                                        Tu navegador no soporta el elemento de video.
                                    </video>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Experiencias;
